<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/extendCommonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "coopAdminUser":"",
                "coopAdminSercet":""
           },
            responseCode: {
                "data": {
                    "coopAppId": "",
                    "coopName": "",
                    "coopSercet": "",
                    "serverUrl": "http://wdl.dev.xxx.com.cn/upward/v2/xx",
                    "status": 1,
                    "upwardApiStatus": 1
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "通过此接口可传递授权商用户名密码获取授权商信息",
                t_url: this.commonUrls.test+"extend/getCoopInfoByCoopAdminUser",
                precondition: "授权商需经由管理员在AOMP为己配置超管信息并开通此接口权限",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'coopAdminUser', info2: '是', info3: 'String', info4: '授权商超管账号' },
                        { info1: 'coopAdminSercet', info2: '是', info3: 'String', info4: '授权商超管密码' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'coopName', info2: '是', info3: 'String', info4: '授权商名称' },
                        { info1: 'serverUrl', info2: '是', info3: 'String', info4: '上报地址' },
                        { info1: 'coopAppId', info2: '是', info3: 'String', info4: '授权标识' },
                        { info1: 'coopSercet', info2: '是', info3: 'String', info4: '授权秘钥' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '状态，0删除 1启用 2禁用' },
                        { info1: 'upwardApiStatus', info2: '是', info3: 'Integer', info4: '上报接口状态，0被冻结 1正常' },
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/other/getCoopInfoByCoopAdminUser.vue